import { RouteRecordRaw } from "vue-router";

export const top: RouteRecordRaw = {
  path: "",
  name: "Top",
  component: () =>
    import(/* webpackChunkName: "top" */ "@/layouts/Default.vue"),
  meta: {
    isStartPage: true,
    isBeforeLogin: true
  }
};
